import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function TransitionBlock() {
  return <section className="py-24 md:py-32 px-6 bg-nude-light" data-id="element-367" data-mp="367a79mkl2p4i">
      <div className="max-w-3xl mx-auto text-center" data-id="element-368" data-mp="31f0n6n65gja5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-369" data-mp="31dfqos09yq9n">
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-gold mb-6 block" data-id="element-370" data-mp="2mk457i8jghjv">
            Tu Rutina, Simplificada
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-luxury-black leading-tight mb-8" data-id="element-371" data-mp="2di39wqwv85ku">
            TODO LO QUE NECESITAS, <br className="hidden md:block" data-id="element-372" data-mp="gojd50frh1rp" />
            <span className="italic text-gray-500" data-id="element-373" data-mp="bq81ck5woh6u">EN UN SOLO KIT</span>
          </h2>

          <div className="space-y-4 text-gray-600 font-sans font-light text-lg md:text-xl leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-374" data-mp="39p3hgtays849">
            <p data-id="element-375" data-mp="3eoge25rn0tk1">Olvídate de buscar, mezclar o improvisar.</p>
            <p data-id="element-376" data-mp="3eltybiulf7qq">
              Cada detalle fue pensado para que tengas a la mano lo esencial
              para verte profesional, organizada y segura… en cualquier momento.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto mb-14" data-id="element-377" data-mp="3td2sm59fxha7">
            {['Organización total en segundos', 'Diseño elegante y profesional', 'Ideal para uso diario o trabajo', 'Perfecto para llevar contigo a cualquier lugar'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1 * i
          }} className="flex items-center gap-3 text-sm text-gray-700" data-id="element-378" data-mp="3ol2y4sc53gl0" data-mpi={i}>
                <Check className="w-4 h-4 text-gold shrink-0" data-id="element-379" data-mp="kwwq1dy85654" />
                <span data-id="element-380" data-mp="fv7dtuz9mmfg">{item}</span>
              </motion.div>)}
          </div>

          <div className="mb-14" data-id="element-381" data-mp="bvgo7ulh6cci">
            <div className="w-10 h-0.5 bg-gold mx-auto mb-8" data-id="element-382" data-mp="bwi4qel9fr1m"></div>
            <p className="font-serif text-2xl md:text-3xl italic text-luxury-black" data-id="element-383" data-mp="72x2gacmwawm">
              Menos complicaciones. Más confianza.
            </p>
            <div className="w-10 h-0.5 bg-gold mx-auto mt-8" data-id="element-384" data-mp="3tax1ghxlc5ga"></div>
          </div>

          <p className="text-sm tracking-[0.2em] uppercase text-gray-400 font-medium" data-id="element-385" data-mp="3t92cmsj77t6x">
            Elige el que mejor va contigo ↓
          </p>
        </motion.div>
      </div>
    </section>;
}